module.exports = __webpack_public_path__ + "img/samson.14aa5ef0.jpeg";